import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { key: 2 };
import { computed, ref, useSlots, watch } from "vue";
import Dropdown from "primevue/dropdown";
import InlineMessage from "primevue/inlinemessage";
export default /*#__PURE__*/ _defineComponent({
    __name: 'OneDeskDropdown',
    props: {
        lineraLabel: { type: Boolean, default: true },
        options: {},
        modelValue: {},
        optionLabel: { default: "label" },
        optionValue: { default: "value" },
        filter: { type: Boolean, default: false },
        fullWidth: { type: Boolean, default: false },
        editable: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        required: { type: Boolean, default: false }
    },
    emits: ["update:modelValue", "change", "update:valid"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const slots = useSlots();
        const hasSlot = (name) => !!slots[name];
        const selected = ref(props.modelValue);
        const labelClassName = computed(() => "onedesk-dropdown-label " +
            (props.lineraLabel ? "onedesk-dropdown-label-linear" : ""));
        const oneDeskDropdownClassName = computed(() => "onedesk-dropdown onedesk-input" +
            (props.fullWidth ? " onedesk-dropdown-full-width" : ""));
        watch(() => props.modelValue, (value) => selected.value = value);
        watch(selected, (currentValue) => {
            if (props.required)
                emit("update:valid", !!currentValue);
            emit("update:modelValue", currentValue);
        });
        const onChange = (event) => emit("change", event);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(oneDeskDropdownClassName.value)
            }, [
                (hasSlot('label'))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(labelClassName.value)
                    }, [
                        _renderSlot(_ctx.$slots, "label")
                    ], 2))
                    : _createCommentVNode("", true),
                _createVNode(_unref(Dropdown), {
                    modelValue: selected.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selected).value = $event)),
                    options: props.options,
                    "option-label": props.optionLabel,
                    "option-value": props.optionValue,
                    filter: props.filter,
                    editable: props.editable,
                    disabled: props.disabled,
                    onChange: _cache[1] || (_cache[1] = ($event) => (onChange($event)))
                }, null, 8, ["modelValue", "options", "option-label", "option-value", "filter", "editable", "disabled"]),
                (props.required && !selected.value)
                    ? (_openBlock(), _createBlock(_unref(InlineMessage), {
                        key: 1,
                        severity: "error",
                        class: "my-2"
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(" This field is mandatory ")
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true),
                (hasSlot('error'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _renderSlot(_ctx.$slots, "error")
                    ]))
                    : _createCommentVNode("", true)
            ], 2));
        };
    }
});
